import { useMutation } from '@tanstack/react-query'
import { supabase } from '../api'

const addAssetRequest = async (
  name: string,
  ticker: string,
  description: string,
) => {
  if (!name) throw new Error('Name should not be empty')

  const { data, error } = await supabase
    .from('request_asset')
    .insert({
      name,
      ticker,
      description,
    });

  if (error) {
    throw new Error(error.message)
  }

  return data
}

export default function useAddAssetRequest(
  name: string,
  ticker: string,
  description: string,
) {
  return useMutation(() => addAssetRequest(name, ticker, description), {
    onSuccess: async (res) => res,
  })
}
